module.exports = {"id":"194916","name":"António Filipe","rating":"72","photo":"./data/images/photos/3/194916.png","club":{"name":"Chaves","logo":"./data/images/clubs/Chaves.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AntonioFilipe0.json
// module id = 442
// module chunks = 0